export default {"src":"/_next/static/media/react_logo_6178518320.527e3153.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};